// Fieldset is a simple bordered container with a floating label used to visually group related UI elements.

import './Fieldset.scss';

export default function Fieldset({ label, className, children, small }) {
  return (
    <div
      className={
        'fieldset' +
        (small ? ' small' : '') +
        (className ? ' ' + className : '')
      }
    >
      {children}
      <p className='label visible'>{label}</p>
    </div>
  );
}
